import { computed, readonly, ref } from 'vue'
import { defineStore } from 'pinia'
import type { POSTokenPayload, SSBTTokenPayload } from '@nsftx/seven-client-sdk-integrator'

type TokenPayload = SSBTTokenPayload | POSTokenPayload

const unpackToken = (token: string): TokenPayload => {
  const [, payload] = token.split('.')
  return JSON.parse(atob(payload!))
}

const useTokenPayloadStore = defineStore('tokenPayloadStore', () => {
  const tokenPayload = ref<TokenPayload | null>(null)

  const setToken = (accessToken: string) => {
    tokenPayload.value = unpackToken(accessToken)
  }

  const baseCurrency = computed(() => tokenPayload.value?.identity.tenant.baseCurrency)

  const supportedCurrencies = computed(
    () => tokenPayload.value?.identity.tenant.supportedCurrencies
  )

  return {
    tokenPayload: readonly(tokenPayload),
    baseCurrency,
    supportedCurrencies,
    setToken
  }
})

export { useTokenPayloadStore }
